import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import { GlobalProvider } from '../global/global';
/*
  Generated class for the LoginProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class LoginProvider {
  public isLoggedIn: boolean = false
  // private api: string = "http://192.168.1.161/ionic3/macabeo/webservicesappvinos/API.php"
 // private api: string = "http://www.appstocks.es/macabeo/webservices/api/"
 private api: string = "";

  constructor(public http: Http, public global:GlobalProvider) {
    this.api = this.global.api;
    console.log('Hello LoginProvider Provider');
  }
  public login(user): Observable<any>  {
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros = {
      email: '"' + user.email + '"',
      password: '"' + user.password + '"'
    };
   
    return this.http.post(this.api+'ws_login.php', parametros, options).map(
      (response) => {
      
        
        return response.json();
      }
    ).catch(this.handleError);
  }
  public token(): Observable<any>  {
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros = {
      "p1":"pp",
      "p2":"aa"
     
    };
   // alert(this.api+'ws_token.php');
    return this.http.post(this.api+'ws_token.php', parametros, options).map(
      (response) => {
      //  alert(response['_body']);
        
        return response.json();
      }
    ).catch(this.handleError);
  }
  public registro(user): Observable<any>  {
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros = user
    return this.http.post(this.api+'ws_registro.php', parametros, options).map(
      (response) => {
        
        return response.json();
      }
    ).catch(this.handleError);
  }
  public modifica_registro(user): Observable<any>  {
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros = user
    return this.http.post(this.api+'ws_modificaregistro.php', parametros, options).map(
      (response) => {
        
        return response.json();
      }
    ).catch(this.handleError);
  }
  public password(user): Observable<any>  {
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros = {
      email: '"' + user.email + '"'
    };
    
    return this.http.post(this.api+'ws_password.php', parametros, options).map(
      (response) => {
        
      
        return response.json();
      }
    ).catch(this.handleError);
  }
  public baja(user): Observable<any>  {
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros = {
      id:  user.id ,
      token: user.token 
    };
    
    return this.http.post(this.api+'ws_baja.php', parametros, options).map(
      (response) => {
        
     
        return response.json();
      }
    ).catch(this.handleError);
  }
 /* public login(user) {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros = {
      email: '"' + user.email + '"',
      password: '"' + user.password + '"'
    };
    return this.http.post('http://www.appstocks.es/macabeo/webservices/api/ws_login.php', parametros, options).map(
      (response) => {
        
        return response.json();
      }
    )
  }
  public registro(user) {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros = user
    return this.http.post('http://www.appstocks.es/macabeo/webservices/api/ws_registro.php', parametros, options).map(
      (response) => {
        
        return response.json();
      }
    )
  }*/
  private handleError (error: Response | any) {
    // In a real world app, you might use a remote logging infrastructure
    let errMsg: string;
    if (error instanceof Response) {
      //alert('1');
      const body = error.json() || '';
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
     // alert('2');
      errMsg = error.message ? error.message : error.toString();
    }
    //alert(errMsg);
    console.error(errMsg);
    return Observable.throw(errMsg);
  }
}



// WEBPACK FOOTER //
// ./src/providers/login/login.ts